/* src/app/portal/shared/datafilter/datafilter.component.scss */
.data-filter-container .filter-row-padding {
  padding-top: 10px;
}
.data-filter-btns .btn-right {
  display: flex;
  justify-content: flex-end;
}
.data-filter-btns .btn-space {
  margin-left: 10px;
}
/*# sourceMappingURL=datafilter.component-7HTHBV27.css.map */
